import { useHistory } from 'react-router-dom';
import { useTranslation } from 'Shared/util/custom-hooks';
import Page from 'Shared/components/page/page';
import Description from 'Shared/components/description';
import InlineSvg from 'Shared/components/inline-svg';
import Button from 'Shared/components/button';
import EmptyStateDescription from '../components/empty-state-description';
import styles from './onboarding-empty-state-view.css';


const OnboardingEmptyStateView = () => {
  const history = useHistory();
  const troot = useTranslation(x => x.landing.empty_state);
  const { onboarding: t } = troot;

  const handleCompanySettingsClick = () => history.push('/company-settings');

  return (
    <Page
      narrowWidth
      title={{
        text: troot.welcome,
        reducedMarginBottom: true,
      }}
    >
      <div className={styles.container}>
        <Description text={t.introduction} />
        <InlineSvg
          src="/illustrations/onboarding-steps.svg"
          className={styles.onboardingStepsSvgContainer}
        />
        <Button
          buttonType="action-primary"
          text={t.get_started}
          onClick={handleCompanySettingsClick}
          className={styles.companySettingsButton}
        />
        <h3>{t.about_my_pages}</h3>
        <EmptyStateDescription
          translations={troot}
          introductionText={t.description}
        />
      </div>
    </Page>
  );
};

export default OnboardingEmptyStateView;
